import { FC, ReactNode, useState } from 'react';
import Sidebar from './Sidebar';
import Footer from './Footer';
import TourGuide from './TourGuide';
import QuotaErrorHost from './QuotaErrorHost';
import AgentFeatureBlockedHost from './AgentFeatureBlockedHost';
import SeopFeatureBlockedHost from './SeopFeatureBlockedHost';
import DashboardFeatureBlockedHost from './DashboardFeatureBlockedHost';

interface AppLayoutProps {
  children: ReactNode;
  /** Esconde o rodapé em telas full-bleed (ex.: chat do agente, que preenche a viewport). */
  hideFooter?: boolean;
}

const AppLayout: FC<AppLayoutProps> = ({ children, hideFooter = false }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-surface-primary text-content-primary flex">
      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsMobileMenuOpen(true)}
        className="print-hide fixed top-4 left-4 z-30 lg:hidden bg-accent p-3 rounded-xl shadow-lg"
        aria-label="Abrir menu"
      >
        <span className="material-symbols-outlined text-white">menu</span>
      </button>

      <Sidebar isMobileOpen={isMobileMenuOpen} onMobileClose={() => setIsMobileMenuOpen(false)} />
      {/* pt-16 no mobile reserva espaço para o botão hamburger fixo */}
      <main className="flex-1 flex flex-col min-w-0 overflow-y-auto pt-16 lg:pt-0 print:pt-0">
        {children}
        {!hideFooter && <Footer />}
      </main>
      <TourGuide />
      {/* P14: modais 402 (cota estourada) disparados pelo interceptor */}
      <QuotaErrorHost />
      {/* Gate Hub de Agentes: toast pra 403 mid-session disparado pelo interceptor */}
      <AgentFeatureBlockedHost />
      {/* Idem para o Balanceamento de Linha (frente SEOP) */}
      <SeopFeatureBlockedHost />
      {/* Idem para os painéis executivos (/paineis) */}
      <DashboardFeatureBlockedHost />
    </div>
  );
};

export default AppLayout;
